import { combineReducers } from 'redux';

import * as types from 'modules/chat/actionTypes';
import { CONVERSATION_CONTEXT_SELECT } from 'modules/chat/constant';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  selected: string | null,
 *  select: import("modules/global/reducers/simpleSearchReducer").SimpleSearchReducer,
 * }} ChatUIDetailsContextReducer
 */

const matcher = ({ meta }) => meta?.source === CONVERSATION_CONTEXT_SELECT;

const selectReducer = createSearchReducers(types.FETCH_CONVERSATION_CONTEXT, {
  global: {
    matcher,
  },
});

export default combineReducers({
  selected: createReducer(null, {
    [types.SET_CONTEXT_ID]: (_, { payload: contextId }) => contextId,
    [LOCATION_CHANGE]: () => null,
  }),
  select: (state, action) => (action.type === LOCATION_CHANGE ? selectReducer(undefined, action) : selectReducer(state, action)),
});
